<template>
    <div class="archive-players box">
        <transition
            name="fade"
        >
            <div
                v-if="playersUpdate"
                class="new-player-loader"
            >
                <base-loader />
            </div>
        </transition>
        <div class="box-title">
            Archive Players
            <base-submit-button
                class="btn add-btn"
                :loading="formProcessing"
                @click="createPlayer"
            >
                New Archive Player
            </base-submit-button>
        </div>
        <div class="box-content">
            <transition-group
                name="fade"
                mode="out-in"
            >
                <div
                    key="players-controls"
                    class="player-controls list-control"
                >
                    <base-list-control
                        v-for="control in controls"
                        :key="control.title"
                        :config="control"
                        :sort-by="sortBy"
                        :is-reverse="isReverse"
                        @change="controlsChange"
                    />
                </div>
                <base-loader
                    v-if="! players"
                    key="loader"
                />
                <p
                    v-else-if="0 === players.length"
                    key="empty-players"
                >
                    No players to display
                </p>
                <ul
                    v-else
                    key="players-list"
                    class="players-list list"
                >
                    <archive-player
                        v-for="player in sortedPlayers"
                        :key="player.hash"
                        :player="player"
                        :show="show"
                        @player-delete="value => playersUpdate = value"
                        @click="value => $emit('click', value)"
                        @error="value => errorMessage(value)"
                    />
                </ul>
            </transition-group>
        </div>
    </div>
</template>

<script>
import { sortBy } from 'lodash';
import dataChangeHandler from '@/utils/dataChangeHandler';
import ArchivePlayer from './ArchivePlayer';
import toasts from '@/mixins/toasts';
import { mapActions } from 'vuex';

export default {
    components: {
        ArchivePlayer,
    },

    mixins: [toasts],

    props: {
        players: {
            type: [Array, Boolean],
            required: true,
        },
        show: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        controls: [
            {
                listLabel: 'Player Name',
                value: 'title',
            },
        ],
        sortBy: null,
        isReverse: false,
        formProcessing: false,
        playersUpdate: false,
    }),

    computed: {
        /**
         * Returns sorted players
         *
         * @returns  {Array}  Sorted players
         */
        sortedPlayers() {
            if (! this.sortBy) {
                return this.players;
            }

            let players = this.players;
            players = sortBy(players, [this.sortBy]);

            return this.isReverse ? players.reverse(players) : players;
        },
    },

    methods: {
        ...mapActions(['addPlayer']),

        /**
         * Handle controls change
         *
         * @param {object} changed  Changed configuation
         */
        controlsChange(changed) {
            dataChangeHandler(this, changed);
        },

        /**
         * Creates new player
         *
         */
        async createPlayer() {
            if (this.playersUpdate) {
                return;
            }

            this.playersUpdateIndicator();

            try {
                await this.addPlayer({
                    playerNumber: this.players.length + 1,
                    showId: this.show.id,
                    hash: this.show.hash,
                });

                this.$emit(
                    'click',
                    {
                        editPlayerType: 'archive',
                        player: this.players[this.players.length - 1],
                    }
                );
            } catch (e) {
                this.errorMessage('We could\'t add new player. Please try again later or contact us.');
            }

            this.playersUpdateIndicator();
        },

        /**
         * Indicates loading player
         *
         */
        playersUpdateIndicator() {
            this.playersUpdate = ! this.playersUpdate;
        },

        /**
         * Displays error toast
         *
         * @param {string} title Error message
         */
        errorMessage(title) {
            this.toastError({
                message: { title },
            });
        },
    },
};
</script>
